/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ActiveAlarm: '',
  unreadAlarmCount:0,
  alarms: [],
  alarmSearchQuery: '',
  alarmUnread: false,
  alarmFilter:'',
  newAlarms: [],
  alarmTag: [{color:'success',value:'submit', text:'결과물'},
  {color:'primary',value:'notice', text:'클래스공지'},
  {color:'warning', value:'invite', text: '초대'},
  {color: 'danger',value:'system', text: '시스템'}]
}
